import themeDefinitions from './themeConfig.json';

export const themes = themeDefinitions;
export const defaultThemeId = 'original';

/**
 * Themes that ship a dedicated hero portrait under
 * /images/profile-themes/<id>.webp.
 *
 * The Modernist pack renders photography in grayscale via CSS, so it shares one
 * neutral portrait rather than carrying a near-identical copy of the same
 * image. Anything not listed here falls back to that shared file.
 */
const THEMES_WITHOUT_PORTRAIT = new Set([
  'modernist-bone',
  'modernist-ink',
  'modernist-blueprint',
]);

const FALLBACK_PORTRAIT = '/images/profile-themes/modernist.webp';

/**
 * Resolve a theme by id.
 *
 * Falls back to the configured default rather than `themes[0]`: the array order
 * is presentation order in the picker, and the Modernist pack now sits at the
 * top — so an unknown id used to silently resolve to whichever theme happened
 * to be listed first.
 */
export const getThemeById = (themeId) =>
  themes.find((theme) => theme.id === themeId) ||
  themes.find((theme) => theme.id === defaultThemeId) ||
  themes[0];

/**
 * Resolve a stored theme id to one that still exists.
 *
 * Themes get retired — the Gaming & Tech and Nature sets are gone — but a
 * visitor's localStorage still names one, and their CSS went with them. Without
 * this the saved id would be written to data-theme and match nothing, leaving
 * an unstyled page with no obvious way back.
 */
export const resolveThemeId = (themeId) =>
  themes.some((theme) => theme.id === themeId) ? themeId : defaultThemeId;

export const getThemeProfileImage = (themeId) => {
  const activeTheme = getThemeById(themeId);
  if (THEMES_WITHOUT_PORTRAIT.has(activeTheme.id)) return FALLBACK_PORTRAIT;
  return `/images/profile-themes/${activeTheme.id}.webp`;
};
